import React, { useState } from "react";
import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	TextField,
	Typography,
} from "@mui/material";
import useUtils from "../../hooks/useUtilities";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";

const PasswordResetModal = ({ open, onClose }) => {
	const { showSnackbar } = useUtils();
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSetEmail = (e) => {
		e.preventDefault();
		setEmail(e.target.value);
	};

	const handleResetPassword = async (e) => {
		e.preventDefault();
		if (!email) {
			showSnackbar("Please enter your email", "error");
			return;
		}
		try {
			setLoading(true);
			await sendPasswordResetEmail(auth, email);
			showSnackbar("Check your inbox for further instructions", "success");
		} catch {
			showSnackbar(
				"Failed to  send email. Make sure your email is correct.",
				"error"
			);
		}
		setLoading(false);
	};

	return (
		<Dialog
			sx={{
				"& .MuiDialog-paper": {
					borderRadius: "20px",
				},
			}}
			fullWidth
			open={open}
			onClose={onClose}>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
					padding: 4,
				}}>
				<Typography
					sx={{ mb: 2, maxWidth: 400 }}
					textAlign="center"
					variant="h1"
					gutterBottom>
					Reset Password
				</Typography>
				<TextField
					sx={{ mb: 2, maxWidth: 400 }}
					placeholder="Enter your email"
					fullWidth
					value={email}
					onChange={handleSetEmail}
				/>
				<Button
					disableElevation
					startIcon={
						loading && (
							<CircularProgress
								color="inherit"
								size={20}
							/>
						)
					}
					variant="contained"
					sx={{ mb: 2, maxWidth: 400 }}
					fullWidth
					color="secondary"
					onClick={handleResetPassword}>
					Send Password Reset Email
				</Button>
			</Box>
		</Dialog>
	);
};

export default PasswordResetModal;
